import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/i18n/LanguageContext';

export const UserDeleteDialog = ({ user, onConfirm, onCancel }) => {
  const { t } = useLanguage();
  if (!user) return null;
  return (
    <Dialog open={!!user} onOpenChange={(open) => { if (!open) onCancel(); }}>
      <DialogContent className="bg-card border-border max-w-sm">
        <DialogHeader>
          <DialogTitle>{t('users.confirmDelete')}</DialogTitle>
          <DialogDescription className="sr-only">
            {t('users.confirmDeleteDesc')}
          </DialogDescription>
        </DialogHeader>
        <p className="text-sm text-muted-foreground mb-4">
          {t('users.confirmDeleteDesc')} <strong>{user.name}</strong> ({user.email})?
        </p>
        <div className="flex gap-3">
          <Button onClick={() => onConfirm(user.user_id)} variant="destructive" className="flex-1" data-testid="confirm-delete-user">
            {t('common.delete')}
          </Button>
          <Button onClick={onCancel} variant="outline" className="flex-1">
            {t('common.cancel')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
